/**
 * Whether this build is the cut-down beta site.
 *
 * Resolved from `VITE_BETA_MODE` at BUILD time and inlined into the bundle, so there is no
 * runtime flag to tamper with and no way to reach a beta-hidden route by URL.
 *
 * Exported from one module because it was previously re-derived in each file that needed it,
 * and the copies drifted: `buildPublicRoutes` stopped mounting `/pricing` under beta while the
 * navbar and sidebar kept advertising it, so the link rendered and landed on the catch-all
 * 404 — which `marketing-public-nav`'s spec forbids. A nav that decides visibility from a
 * different source than the router decides mounting will always be one edit from doing that
 * again.
 */
export const isBetaMode = import.meta.env.VITE_BETA_MODE === 'true'
